import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { FaRegFileExcel } from 'react-icons/fa'
import {
  BadgeStatusEntrega,
  Btn,
  BtnIcon,
  CustomCheckbox,
  CustomDropdown,
  CustomMultiSelect,
  CustomPanel,
  DateTime,
  Loading,
  PageHeader,
  ThreeDots,
} from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  INIT_STATE,
  onConsiderarEntregasToggle,
  onGetEntregas,
  onLoadingToggle,
  onModalVisibilityToggle,
  onModeloIntegracaoChange,
  onOnResetEntregas,
  onSelecionarEntregaClick,
  onSelecionarTodosClick,
  onSeletedEmpresasChange,
  onSeletedStatusChange,
  reducer,
} from './entregas-para-roteirizacao.state'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import ModalEntregasParaRoteirizacaoDetalhes from './ModalEntregasParaRoteirizacaoDetalhes'
import buildXmlOrtec from '../../../../services/integracao/roteirizacao-ortec-xml.integracao'
import { fetchEntregasParaRoteirizacao } from '../../../../services/api/https/deliveries/entregas-para-roteirizacao.http'
import { azul_escuro } from '../../../../assets/js/colors'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

const EntregasParaRoteirizacao = ({ history, dispatch, selectedTp }) => {
  //Hooks
  const [state, localDispatch] = React.useReducer(reducer, INIT_STATE)
  React.useEffect(() => {
    localDispatch(onOnResetEntregas())
  }, [selectedTp])

  //Events
  const onBtnPesquisarClick = () => getEntregasParaRoteirizacao()

  const onBtnGerarClick = () => {
    try {
      const entregas = state.entregas.filter(e => e.selected)
      if (state.selectedModeloIntegracao === '') throw new Error('Selecione o Modelo de Integração')
      if (entregas.length === 0) throw new Error('Selecione as Entregas desejadas')
      buildXmlOrtec(entregas)
      localDispatch(onOnResetEntregas())
      dispatch(showMessageBox('Exportação Realizada com Sucesso', null))
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const onBtnExcelClick = () => {
    const entregasParaRoteirizacaoExcel = [
      [
        'Cidade',
        'CNPJ',
        'Empresa',
        'DataImportacao',
        'Identificador',
        'LoteCarregamento',
        'NomeFantasia',
        'NotaFiscal',
        'QuantidadeCaixas',
        'Status',
      ],
    ]
    state.entregas
      .filter(e => e.selected)
      .forEach(o => {
        const cells = []
        cells.push(o.city)
        cells.push(o.cnpj_cliente)
        cells.push(o.company_name)
        cells.push(o.dataEmissao)
        cells.push(o.identifier)
        cells.push(o.loteCarregamento)
        cells.push(o.nomeFantasia)
        cells.push(o.nota_fiscal)
        cells.push(o.qteSkuTotal)
        cells.push(o.status)
        entregasParaRoteirizacaoExcel.push(cells)
      })
    gerarArquivoExcel(
      'embarques_roteirizacao',
      entregasParaRoteirizacaoExcel,
      'embarques_roteirizacao.xlsx',
    )
  }
  // Helper
  const getEntregasParaRoteirizacao = async () => {
    try {
      const statusIds = state.selectedStatus
      const empresasIds = state.selectedEmpresas
      const considerarEntregasEmSeparacao = state.considerarEntregasEmSeparacao

      if (statusIds.length === 0) throw new Error('Selecione os Status desejados')
      if (empresasIds.length === 0) throw new Error('Selecione as Empresas desejadas')

      localDispatch(onLoadingToggle(true))

      const fetchedEntregas = await fetchEntregasParaRoteirizacao(
        statusIds,
        empresasIds,
        considerarEntregasEmSeparacao,
        selectedTp,
      )
      fetchedEntregas && fetchedEntregas.length > 0 && localDispatch(onGetEntregas(fetchedEntregas))
    } catch (e) {
      localDispatch(onLoadingToggle(false))
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  // Template
  const filterForm = (
    <div className="p-grid">
      <div className="p-col-3">
        <CustomMultiSelect
          label={'Status'}
          value={state.selectedStatus}
          onChange={itemsSelecionados => localDispatch(onSeletedStatusChange(itemsSelecionados))}
          options={state.listaStatus}
        />
      </div>
      <div className="p-col-2">
        <CustomMultiSelect
          label={'Empresas'}
          value={state.selectedEmpresas}
          onChange={itemsSelecionados => localDispatch(onSeletedEmpresasChange(itemsSelecionados))}
          options={state.listaEmpresas}
        />
      </div>
      <div className="p-col-3" style={{ paddingTop: 52 }}>
        <CustomCheckbox
          checked={state.considerarEntregasEmSeparacao}
          onChange={() => localDispatch(onConsiderarEntregasToggle())}
        >
          Considerar as Entregas em Separação
        </CustomCheckbox>
      </div>
      <div className="p-col-1" style={{ paddingTop: 45 }}>
        <Btn onClick={onBtnPesquisarClick}>Pesquisar</Btn>
      </div>
      {state.entregas.length > 0 ? (
        <div className="p-col-3 text-right" style={{ paddingTop: 30 }}>
          <div style={{ display: 'inline-block' }}>
            <CustomDropdown
              options={[{ value: 'ORTEC_XML', label: 'ORTEC - XML' }]}
              onChange={modelo => localDispatch(onModeloIntegracaoChange(modelo))}
              value={state.selectedModeloIntegracao}
              label={'Modelo de Integração:'}
              marginTop={0}
            />
          </div>
          <div style={{ display: 'inline-block', marginLeft: 10 }}>
            <Btn onClick={onBtnGerarClick}>Gerar</Btn>
          </div>
        </div>
      ) : null}
    </div>
  )
  const dataTable = (
    <>
      <div style={{ marginBottom: 10 }} className="p-grid">
        <div className="p-col-2">
          <CustomCheckbox
            checked={state.selecionarTodos}
            onChange={() => localDispatch(onSelecionarTodosClick())}
          >
            Selecionar Todas
          </CustomCheckbox>
        </div>
        <div className="p-col-10 text-right">
          <BtnIcon onClick={onBtnExcelClick}>
            <FaRegFileExcel size={18} color={azul_escuro} />
          </BtnIcon>
        </div>
      </div>
      <DataTable
        value={state.entregas ? state.entregas : []}
        emptyMessage={'Nenhuma Entrega Encontrada'}
        paginator={true}
        rows={5}
      >
        <Column
          field="selected"
          header={'#'}
          style={tableCellCentered(50)}
          body={entrega => (
            <CustomCheckbox
              checked={entrega.selected}
              onChange={() => localDispatch(onSelecionarEntregaClick(entrega))}
            />
          )}
        />
        <Column
          header={'Status'}
          style={tableCellCentered(100)}
          body={entrega => <BadgeStatusEntrega status={entrega.status} />}
        />
        <Column
          header={'DT. Emissão'}
          style={tableCellCentered()}
          body={entrega => <DateTime>{entrega.dataEmissao}</DateTime>}
        />
        <Column field={'identifier'} header={'Identif.'} style={{ textAlign: 'center' }} />
        <Column field={'nomeFantasia'} header={'Cliente'} />
        <Column field={'city'} header={'Cidade'} />
        <Column field={'qteSkuTotal'} header={'TT. Caixas'} style={tableCellCentered()} />
        <Column field={'company_name'} header={'Empresa'} style={tableCellCentered()} />
        <Column
          header="Menu"
          style={tableCellCentered(70)}
          body={entrega => (
            <ThreeDots
              items={['Detalhes']}
              onClick={item =>
                item === 'Detalhes' ? localDispatch(onModalVisibilityToggle(true, entrega)) : ''
              }
            />
          )}
          bodyStyle={tableCellCentered()}
        />
      </DataTable>
    </>
  )

  //Render
  return (
    <>
      <PageHeader>3.10 - Entregas Para Roteirização</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <>
            {filterForm}
            <div style={{ marginTop: 10 }}>
              {state.isLoading ? (
                <div className="text-center">
                  <Loading size={'md'} />
                </div>
              ) : (
                dataTable
              )}
            </div>
            <ModalEntregasParaRoteirizacaoDetalhes
              entrega={state.selectedEntrega}
              isVisible={state.modalIsVisible}
              onClose={() => localDispatch(onModalVisibilityToggle(false, undefined))}
            />
          </>
        </CustomPanel>
      </div>
    </>
  )
}

const mapToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapToProps)(withRouter(EntregasParaRoteirizacao))
